import React from 'react'
import styles from './styles.css'
import breakitLogo from '../../assets/svgs/breakit-logo-white.svg'

const BreakitBanner = () => (
  <div className={styles.container}>
    <span className={styles.text}>
      ”De ritar om marknaden för fritidsaktiviteter”
    </span>
    <img className={styles.logo} src={breakitLogo} alt="Breakit logo" />
  </div>
)

export default BreakitBanner



// WEBPACK FOOTER //
// ../source/components/BreakitBanner/index.js